<template>
    <div>
        <my_menu2 page_name="提成确认" back_type="close" back_icon="md-close"></my_menu2>
        <div style="height:50px"></div>
        <div class="table_main">
            <div class="table_name">
                <Icon type="md-bookmark" color="#0466dd" size="20" />按月发薪数据统计
            </div>
            <div>
                <Table ref='table' size="small" :height="150" :columns="columns" :data="table_data">
                    <template #export_xls="{ row }">
                        <span class="export_xls" @click="export_xls(row)">下载表格</span>
                    </template>
                    <template #project_count="{ row }">
                        <span class="export_xls" @click="click_project_count(row)">{{ row.project_count }}</span>
                    </template>
                </Table>
            </div>
        </div>
        <div style="height:40px"></div>
        <div class="table_main">
            <div class="table_name">
                <Icon type="md-bookmark" color="#0466dd" size="20" />按月底在职统计
            </div>
            <div>
                <Table ref='table' size="small" :height="150" :columns="columns2" :data="table_data2">
                    <template #export_xls="{ row }">
                        <span class="export_xls" @click="export_xls2(row)">下载表格</span>
                    </template>

                </Table>
            </div>
        </div>
        <Modal v-model="show_project_count" title="关联归属项目" width="300">
            <div>
                <div v-for="(item, i) in project_count_list" :key="i">{{ item }}</div>
            </div>
        </Modal>
    </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
    components: {
        my_menu2,
    },
    data() {

        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度
            columns: [],
            table_data: [],
            show_project_count: false,
            project_count_list: [],
            columns2: [],
            table_data2: [],
        }
    },
    mounted() {
        this.get_table_data()
        this.get_table_data_service_people()
    },
    methods: {

        export_xls2(item) {
            var that = this;
            console.log(item)
            var obj = {
                interview_data: item.interview_data,
                staff_user_id: item.user_id

            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/service_people_export", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        this.$Modal.confirm({
                            title: '提示',
                            content: '<p>导出数据完成，点击确认进行下载</p>',

                            onOk: () => {
                                get_view_file_url(res.data.object_name)
                            },
                            onCancel: () => {

                            }
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },
        click_project_count(item) {
            this.project_count_list = item.project_count_list
            this.show_project_count = true
        },

        export_table() {
            this.$refs.table.exportCsv({
                filename: '发薪人数看板导出'
            });
        },



        export_xls(item) {
            var that = this;
            console.log(item)
            var obj = {
                record_table_dict: item.record_table_dict

            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/payment_people_export", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        this.$Modal.confirm({
                            title: '提示',
                            content: '<p>导出数据完成，点击确认进行下载</p>',

                            onOk: () => {
                                get_view_file_url(res.data.object_name)
                            },
                            onCancel: () => {

                            }
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },

        //获取表格数据
        get_table_data_service_people() {
            var that = this;
            this.loading = true;
            var obj = {
                dep_team_id: this.dep_1,
            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/service_people_table_data", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns2 = res.data.columns;
                        that.table_data2 = res.data.table_data;
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    this.loading = false;
                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },

        //获取表格数据
        get_table_data() {
            var that = this;
            this.loading = true;
            var obj = {
                dep_team_id: '',
            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/payment_people_table_data", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns = res.data.columns;
                        that.table_data = res.data.table_data;
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    this.loading = false;
                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.export_xls {
    color: #0f87ff;
    cursor: pointer;
}

.table_main {
    margin: 0 10px;
}

.table_name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
}
</style>